<template>
  <td class="customer-types-cell">
    <div>
      <div v-for="customer_type in customerTypes" :key="customer_type.id" class="customer-types-container">
        <div class="customer-type-container" v-bind:style="{ 'background-color': customer_type?.type_color?.hex_value }">
          <span>{{ customer_type.name }}</span>
        </div>
        <div v-for="(customer_sub_type, index) in subTypes(customer_type)" v-bind:key="customer_sub_type.id">
          <div v-if="index == 0" class="customer-sub-type-container" v-bind:style="{ 'background-color': customer_sub_type?.sub_type_color?.rgba_value }">
            <span class="customer-sub-type-name">> {{ customer_sub_type.name }}</span>
            <span v-if="subTypes(customer_type).length > 1">+</span>
          </div>
        </div>
      </div>
    </div>
  </td>
</template>

<script>
export default {
  name: 'CustomerTypesCell',
  props: {
    customerTypes: {
      type: Array,
      default() {
        return [];
      }
    },
    customerSubTypes: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    subTypes(type) {
      return this.customerSubTypes.filter((subType) => subType?.type_id == type?.id);
    }
  }
}
</script>

<style scoped>

.customer-types-cell {
  margin-top: 5px;
}
.customer-type-container,
.customer-sub-type-container {
  font-size: 0.50rem;
  padding: 4px 5px;
  display: flex;
  min-width: 95px;
  max-width: 95px;
  min-height: 20px;
  max-height: 50px;
  justify-content: center;
  align-items: center;
  text-align: left;
  background-color: #FFFFFF;
  border: 1px solid #E5E5E5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-left: 5px;
}

@media screen and (max-width: 992px) {
  .customer-type-container,
  .customer-sub-type-container {
    min-width: 70px;
    max-width: 70px;
  }
}

.customer-types-container {
  display: flex;
}
</style>

